
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("744ND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d51e4a53b773461fcacb3f2ef49e80e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $524ca136d29d3c89$var$_react = $524ca136d29d3c89$var$_interopRequireDefault((parcelRequire("42omo")));

var $524ca136d29d3c89$var$_baseNew = $524ca136d29d3c89$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $524ca136d29d3c89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $524ca136d29d3c89$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $524ca136d29d3c89$var$_react.default.createElement($524ca136d29d3c89$var$_baseNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$524ca136d29d3c89$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $524ca136d29d3c89$var$_default = module.exports.default = $524ca136d29d3c89$var$WarningOutlineIcon;

});

parcelRegister("9eOvr", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b2dbadf512f98f64$var$SyncBlockActionsContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $b2dbadf512f98f64$export$1536d3aa2f6b9cd9 = ()=>{
    return (0, $42omo.useContext)($b2dbadf512f98f64$var$SyncBlockActionsContext);
};
const $b2dbadf512f98f64$export$5f0b55764d1d819f = ({ children: children, removeSyncBlock: removeSyncBlock, fetchSyncBlockSourceInfo: fetchSyncBlockSourceInfo })=>{
    const value = (0, $42omo.useMemo)(()=>({
            deleteSyncBlock: removeSyncBlock,
            fetchSourceInfo: fetchSyncBlockSourceInfo
        }), [
        removeSyncBlock,
        fetchSyncBlockSourceInfo
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b2dbadf512f98f64$var$SyncBlockActionsContext.Provider, {
        value: value
    }, children);
};
module.exports["useSyncBlockActions"] = $b2dbadf512f98f64$export$1536d3aa2f6b9cd9;
module.exports["SyncBlockActionsProvider"] = $b2dbadf512f98f64$export$5f0b55764d1d819f;

});

parcelRegister("lEQpi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $ejAeh = parcelRequire("ejAeh");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $QkKjT = parcelRequire("QkKjT");


var $3RNNl = parcelRequire("3RNNl");


var $dBGrG = parcelRequire("dBGrG");

class $f2fbfd8272c84174$export$d353efb45bc662f4 {
    async fetchReferencesSourceInfo(resourceId, blockInstanceId, isSourceSyncBlock) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.fetchReferencesExperience?.start();
            const response = await this.dataProvider.fetchReferences(resourceId, isSourceSyncBlock);
            if (response.error) {
                this.fetchReferencesExperience?.failure({
                    reason: response.error
                });
                return {
                    error: response.error
                };
            }
            if (!response.references || response.references?.length === 0) {
                // No reference found
                if (isSourceSyncBlock) this.fetchReferencesExperience?.success();
                else this.fetchReferencesExperience?.failure({
                    reason: 'No references found for reference synced block'
                });
                return isSourceSyncBlock ? {
                    references: []
                } : {
                    error: (0, $awHlv.SyncBlockError).Errored
                };
            }
            this.fetchReferencesExperience?.success();
            const sourceInfoPromises = response.references.map(async (reference)=>{
                this.fetchSourceInfoExperience?.start();
                const sourceInfo = await this.dataProvider?.fetchSyncBlockSourceInfo(reference.blockInstanceId || '', reference.documentAri, (0, $ejAeh.getProductFromSourceAri)(reference.documentAri), this.fireAnalyticsEvent, reference.hasAccess, 'view');
                if (!sourceInfo) {
                    this.fetchSourceInfoExperience?.failure({
                        reason: `no source info returned for ari: ${reference.documentAri}`
                    });
                    return undefined;
                }
                this.fetchSourceInfoExperience?.success();
                return {
                    ...sourceInfo,
                    onSameDocument: reference.onSameDocument,
                    hasAccess: reference.hasAccess,
                    productType: sourceInfo.productType
                };
            });
            const sourceInfos = await Promise.all(sourceInfoPromises);
            const sourceSyncBlockData = await (isSourceSyncBlock ? this.sourceSyncBlockStoreManager.getSyncBlockSourceInfo(blockInstanceId) : this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfo(resourceId));
            if (sourceSyncBlockData) sourceInfos.push({
                ...sourceSyncBlockData,
                onSameDocument: Boolean(sourceSyncBlockData?.onSameDocument),
                hasAccess: true,
                isSource: true,
                productType: sourceSyncBlockData?.productType
            });
            return {
                references: sourceInfos
            };
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchReferencesErrorPayload)(error.message));
            return {
                error: (0, $awHlv.SyncBlockError).Errored
            };
        }
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.referenceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        this.sourceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        if ((0, $dh538.fg)('platform_synced_block_dogfooding')) {
            this.fetchReferencesExperience = (0, $QkKjT.getFetchReferencesExperience)(fireAnalyticsEvent);
            this.fetchSourceInfoExperience = (0, $QkKjT.getFetchSourceInfoExperience)(fireAnalyticsEvent);
        }
    }
    get referenceManager() {
        return this.referenceSyncBlockStoreManager;
    }
    get sourceManager() {
        return this.sourceSyncBlockStoreManager;
    }
    destroy() {
        this.referenceSyncBlockStoreManager.destroy();
        this.sourceSyncBlockStoreManager.destroy();
        this.fetchReferencesExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
    }
    constructor(dataProvider){
        this.referenceSyncBlockStoreManager = void 0;
        this.sourceSyncBlockStoreManager = void 0;
        this.dataProvider = void 0;
        this.fireAnalyticsEvent = void 0;
        this.fetchReferencesExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        // In future, if reference manager needs to reach to source manager and read it's current in memorey cache
        // we can pass the source manager as a parameter to the reference manager constructor
        this.sourceSyncBlockStoreManager = new (0, $dBGrG.SourceSyncBlockStoreManager)(dataProvider);
        this.referenceSyncBlockStoreManager = new (0, $3RNNl.ReferenceSyncBlockStoreManager)(dataProvider);
        this.dataProvider = dataProvider;
    }
}
const $f2fbfd8272c84174$var$createSyncBlockStoreManager = (dataProvider)=>{
    return new $f2fbfd8272c84174$export$d353efb45bc662f4(dataProvider);
};
const $f2fbfd8272c84174$export$d95b04bc16414394 = (dataProvider, fireAnalyticsEvent)=>{
    const syncBlockStoreManager = (0, $42omo.useMemo)(()=>{
        const syncBlockStoreManager = $f2fbfd8272c84174$var$createSyncBlockStoreManager(dataProvider);
        return syncBlockStoreManager;
    }, [
        dataProvider
    ]);
    syncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
    return syncBlockStoreManager;
};
module.exports["SyncBlockStoreManager"] = $f2fbfd8272c84174$export$d353efb45bc662f4;
module.exports["useMemoizedSyncBlockStoreManager"] = $f2fbfd8272c84174$export$d95b04bc16414394;

});

parcelRegister("QkKjT", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $grmt9 = parcelRequire("grmt9");

var $8kPu1 = parcelRequire("8kPu1");

var $fo9p3 = parcelRequire("fo9p3");

const $48856e1ef5d8a6d7$var$TIMEOUT_DURATION = 30000;
const $48856e1ef5d8a6d7$export$b335cfa3334e49e6 = (fireAnalyticsEvent)=>{
    return (payload)=>{
        // Runtime type guard - only forward experience events
        if (payload.action === (0, $d925B.ACTION).EXPERIENCE_MEASURED || payload.action === (0, $d925B.ACTION).EXPERIENCE_SAMPLED) fireAnalyticsEvent?.(payload);
    };
};
const $48856e1ef5d8a6d7$export$553df56755696c09 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_UPDATE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$188e7890e84f55e4 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).REFERENCE_SYNCED_BLOCK_UPDATE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$bbbbcdec37b3c0c0 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_FETCH,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$cf32ad2bf7484097 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_GET_SOURCE_INFO,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$666920a07aaa7d43 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_DELETE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$bf943e4a2bda18f6 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_CREATE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$3ba8782eb93c9adf = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_FETCH_REFERENCES,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
module.exports["getSaveSourceExperience"] = $48856e1ef5d8a6d7$export$553df56755696c09;
module.exports["getSaveReferenceExperience"] = $48856e1ef5d8a6d7$export$188e7890e84f55e4;
module.exports["getFetchExperience"] = $48856e1ef5d8a6d7$export$bbbbcdec37b3c0c0;
module.exports["getFetchSourceInfoExperience"] = $48856e1ef5d8a6d7$export$cf32ad2bf7484097;
module.exports["getDeleteSourceExperience"] = $48856e1ef5d8a6d7$export$666920a07aaa7d43;
module.exports["getCreateSourceExperience"] = $48856e1ef5d8a6d7$export$bf943e4a2bda18f6;
module.exports["getFetchReferencesExperience"] = $48856e1ef5d8a6d7$export$3ba8782eb93c9adf;

});

parcelRegister("3RNNl", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $4FxUL = parcelRequire("4FxUL");


var $dh538 = parcelRequire("dh538");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $QkKjT = parcelRequire("QkKjT");


var $4wATI = parcelRequire("4wATI");


var $47N43 = parcelRequire("47N43");


var $gtauf = parcelRequire("gtauf");

class $bf9ff2ea047058dc$export$fb04276dca31302e {
    /**
   * Enables or disables real-time GraphQL subscriptions for block updates.
   * When enabled, the store manager will subscribe to real-time updates
   * instead of relying on polling.
   * @param enabled - Whether to enable real-time subscriptions
   */ setRealTimeSubscriptionsEnabled(enabled) {
        if (this.useRealTimeSubscriptions === enabled) return;
        this.useRealTimeSubscriptions = enabled;
        if (enabled) // Set up subscriptions for all currently subscribed blocks
        this.setupGraphQLSubscriptionsForAllBlocks();
        else // Clean up all GraphQL subscriptions
        this.cleanupAllGraphQLSubscriptions();
    }
    /**
   * Checks if real-time subscriptions are currently enabled.
   */ isRealTimeSubscriptionsEnabled() {
        return this.useRealTimeSubscriptions;
    }
    /**
   * Returns all resource IDs that are currently subscribed to.
   * Used by React components to render subscription components.
   */ getSubscribedResourceIds() {
        return Array.from(this.subscriptions.keys());
    }
    /**
   * Registers a listener that will be called when subscriptions change.
   * @param listener - Callback function to invoke when subscriptions change
   * @returns Unsubscribe function to remove the listener
   */ onSubscriptionsChanged(listener) {
        this.subscriptionChangeListeners.add(listener);
        return ()=>{
            this.subscriptionChangeListeners.delete(listener);
        };
    }
    /**
   * Notifies all subscription change listeners.
   */ notifySubscriptionChangeListeners() {
        this.subscriptionChangeListeners.forEach((listener)=>{
            try {
                listener();
            } catch (error) {
                (0, $hWRJP.logException)(error, {
                    location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/notifySubscriptionChangeListeners'
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
            }
        });
    }
    /**
   * Handles incoming data from a GraphQL subscription.
   * Called by React subscription components when they receive updates.
   * @param syncBlockInstance - The updated sync block instance
   */ handleSubscriptionUpdate(syncBlockInstance) {
        if (!syncBlockInstance.resourceId) return;
        const existingSyncBlock = this.getFromCache(syncBlockInstance.resourceId);
        const resolvedSyncBlockInstance = existingSyncBlock ? (0, $4wATI.resolveSyncBlockInstance)(existingSyncBlock, syncBlockInstance) : syncBlockInstance;
        this.updateCache(resolvedSyncBlockInstance);
        if (!syncBlockInstance.error) this.fetchSyncBlockSourceInfo(resolvedSyncBlockInstance.resourceId);
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.fetchExperience = (0, $QkKjT.getFetchExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $QkKjT.getFetchSourceInfoExperience)(fireAnalyticsEvent);
        this.saveExperience = (0, $QkKjT.getSaveReferenceExperience)(fireAnalyticsEvent);
    }
    setOnUnpublishedSyncBlockDetected(callback) {
        this.onUnpublishedSyncBlockDetected = callback;
    }
    /**
   * Mark a sync block as newly added to the document.
   * This should be called when a sync block node is added via a transaction.
   * @param resourceId - The resource ID of the newly added sync block
   */ markAsNewlyAdded(resourceId) {
        this.newlyAddedSyncBlocks.add(resourceId);
    }
    generateResourceIdForReference(sourceId) {
        if (!this.dataProvider) throw new Error('Data provider not set');
        return this.dataProvider.generateResourceIdForReference(sourceId);
    }
    updateFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
    }
    getInitialSyncBlockData(resourceId) {
        const syncBlockNode = (0, $gtauf.createSyncBlockNode)('', resourceId);
        return this.getFromCache(resourceId) || this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
    }
    /**
   * Refreshes the subscriptions for all sync blocks.
   * This is a fallback polling mechanism when real-time subscriptions are not enabled.
   * @returns {Promise<void>}
   */ async refreshSubscriptions() {
        // Skip polling refresh if real-time subscriptions are enabled
        if (this.useRealTimeSubscriptions) return;
        if (this.isRefreshingSubscriptions) return;
        this.isRefreshingSubscriptions = true;
        const syncBlocks = [];
        for (const [resourceId, callbacks] of this.subscriptions.entries())Object.keys(callbacks).forEach((localId)=>{
            syncBlocks.push((0, $gtauf.createSyncBlockNode)(localId, resourceId));
        });
        try {
            // fetch latest data for all subscribed sync blocks
            // this function will update the cache and call the subscriptions
            await this.fetchSyncBlocksData(syncBlocks);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
        } finally{
            this.isRefreshingSubscriptions = false;
        }
    }
    /**
   * Sets up a GraphQL subscription for a specific block.
   * @param resourceId - The resource ID of the block to subscribe to
   */ setupGraphQLSubscription(resourceId) {
        // Don't set up duplicate subscriptions
        if (this.graphqlSubscriptions.has(resourceId)) return;
        if (!this.dataProvider?.subscribeToBlockUpdates) return;
        const unsubscribe = this.dataProvider.subscribeToBlockUpdates(resourceId, (syncBlockInstance)=>{
            // Handle the subscription update
            this.handleGraphQLSubscriptionUpdate(syncBlockInstance);
        }, (error)=>{
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/graphql-subscription'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
        });
        if (unsubscribe) this.graphqlSubscriptions.set(resourceId, unsubscribe);
    }
    /**
   * Handles updates received from GraphQL subscriptions.
   * @param syncBlockInstance - The updated sync block instance
   */ handleGraphQLSubscriptionUpdate(syncBlockInstance) {
        if (!syncBlockInstance.resourceId) throw new Error('Sync block instance provided to graphql subscription update missing resource id');
        const existingSyncBlock = this.getFromCache(syncBlockInstance.resourceId);
        const resolvedSyncBlockInstance = existingSyncBlock ? (0, $4wATI.resolveSyncBlockInstance)(existingSyncBlock, syncBlockInstance) : syncBlockInstance;
        this.updateCache(resolvedSyncBlockInstance);
        if (!syncBlockInstance.error) {
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchSuccessPayload)(syncBlockInstance?.resourceId, syncBlockInstance?.data?.blockInstanceId, syncBlockInstance?.data?.product));
            this.fetchSyncBlockSourceInfo(resolvedSyncBlockInstance.resourceId);
        } else this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(syncBlockInstance.error?.type, syncBlockInstance.resourceId));
    }
    /**
   * Cleans up the GraphQL subscription for a specific block.
   * @param resourceId - The resource ID of the block to unsubscribe from
   */ cleanupGraphQLSubscription(resourceId) {
        const unsubscribe = this.graphqlSubscriptions.get(resourceId);
        if (unsubscribe) {
            unsubscribe();
            this.graphqlSubscriptions.delete(resourceId);
        }
    }
    /**
   * Sets up GraphQL subscriptions for all currently subscribed blocks.
   */ setupGraphQLSubscriptionsForAllBlocks() {
        for (const resourceId of this.subscriptions.keys())this.setupGraphQLSubscription(resourceId);
    }
    /**
   * Cleans up all GraphQL subscriptions.
   */ cleanupAllGraphQLSubscriptions() {
        for (const unsubscribe of this.graphqlSubscriptions.values())unsubscribe();
        this.graphqlSubscriptions.clear();
    }
    fetchSyncBlockSourceInfoBySourceAri(sourceAri, hasAccess = true, urlType = 'view') {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const sourceInfo = this.dataProvider.fetchSyncBlockSourceInfo(undefined, sourceAri, undefined, undefined, hasAccess, urlType);
            return sourceInfo;
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/fetchSyncBlockSourceInfoBySourceAri'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchSyncBlockSourceInfo(resourceId) {
        try {
            if (!resourceId || !this.dataProvider) throw new Error('Data provider or resourceId not set');
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) {
                const existingRequest = this.syncBlockSourceInfoRequests.get(resourceId);
                if (existingRequest) return existingRequest;
            } else if (this.syncBlockSourceInfoRequestsOld.get(resourceId)) return Promise.resolve(undefined);
            const existingSyncBlock = this.getFromCache(resourceId);
            if (!existingSyncBlock) throw new Error('No existing sync block to fetch source info for');
            const { sourceAri: sourceAri, product: product, blockInstanceId: blockInstanceId, sourceURL: sourceURL, sourceTitle: sourceTitle, onSameDocument: onSameDocument, sourceSubType: sourceSubType } = existingSyncBlock.data || {};
            // skip if source URL and title are already present
            if (sourceURL && sourceTitle) {
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) return Promise.resolve({
                    title: sourceTitle,
                    url: sourceURL,
                    subType: sourceSubType,
                    sourceAri: sourceAri || '',
                    onSameDocument: onSameDocument,
                    productType: product
                });
                else return Promise.resolve(undefined);
            }
            if (!sourceAri || !product || !blockInstanceId) {
                this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('SourceAri, product or blockInstanceId missing', resourceId));
                return Promise.resolve(undefined);
            }
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.fetchSourceInfoExperience?.start({});
            const sourceInfoPromise = this.dataProvider.fetchSyncBlockSourceInfo(blockInstanceId, sourceAri, product, this.fireAnalyticsEvent).then((sourceInfo)=>{
                if (!sourceInfo) {
                    if ((0, $dh538.fg)('platform_synced_block_dogfooding')) {
                        this.fetchSourceInfoExperience?.failure({
                            reason: 'No source info returned'
                        });
                        this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('No source info returned', resourceId));
                    }
                    return undefined;
                }
                this.updateCacheWithSourceInfo(resourceId, sourceInfo);
                if (sourceInfo.title) this.updateSourceTitleSubscriptions(resourceId, sourceInfo.title);
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) {
                    if (sourceInfo.title && sourceInfo.url) this.fetchSourceInfoExperience?.success();
                    else {
                        this.fetchSourceInfoExperience?.failure({
                            reason: 'Missing title or url'
                        });
                        this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('Missing title or url', resourceId));
                    }
                    return sourceInfo;
                }
            }).catch((error)=>{
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.fetchSourceInfoExperience?.failure({
                    reason: error.message
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message, resourceId));
                return undefined;
            }).finally(()=>{
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.syncBlockSourceInfoRequests.delete(resourceId);
                else this.syncBlockSourceInfoRequestsOld.delete(resourceId);
            });
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) {
                this.syncBlockSourceInfoRequests.set(resourceId, sourceInfoPromise);
                return sourceInfoPromise;
            } else this.syncBlockSourceInfoRequestsOld.set(resourceId, true);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message, resourceId));
        }
        return Promise.resolve(undefined);
    }
    /**
   * Fetch sync block data for a given array of sync block nodes.
   * @param syncBlockNodes - The array of sync block nodes to fetch data for
   * @returns The fetched sync block data results
   */ async fetchSyncBlocksData(syncBlockNodes) {
        if (syncBlockNodes.length === 0) return;
        // Don't fetch for not_found error since the source is already deleted
        const nodesToFetch = [];
        syncBlockNodes.forEach((node)=>{
            if (this.syncBlockFetchDataRequests.get(node.attrs.resourceId)) return;
            const existingSyncBlock = this.getFromCache(node.attrs.resourceId);
            if (existingSyncBlock?.error?.type === (0, $awHlv.SyncBlockError).NotFound) return;
            nodesToFetch.push(node);
        });
        if (nodesToFetch.length === 0) return;
        if (!this.dataProvider) throw new Error('Data provider not set');
        nodesToFetch.forEach((node)=>{
            this.syncBlockFetchDataRequests.set(node.attrs.resourceId, true);
        });
        if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.fetchExperience?.start({});
        const data = await this.dataProvider.fetchNodesData(nodesToFetch).finally(()=>{
            nodesToFetch.forEach((node)=>{
                this.syncBlockFetchDataRequests.delete(node.attrs.resourceId);
            });
        });
        let hasUnexpectedError = false;
        let hasExpectedError = false;
        data.forEach((syncBlockInstance)=>{
            if (!syncBlockInstance.resourceId) {
                this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(syncBlockInstance.error?.type || 'Returned sync block instance does not have resource id'));
                return;
            }
            const existingSyncBlock = this.getFromCache(syncBlockInstance.resourceId);
            const resolvedSyncBlockInstance = existingSyncBlock ? (0, $4wATI.resolveSyncBlockInstance)(existingSyncBlock, syncBlockInstance) : syncBlockInstance;
            this.updateCache(resolvedSyncBlockInstance);
            // Check if this is a newly added unpublished sync block and notify
            // Only trigger for sync blocks that were just added (not refreshed or loaded on page init)
            if (!syncBlockInstance.error && resolvedSyncBlockInstance.data?.status === 'unpublished' && this.newlyAddedSyncBlocks.has(syncBlockInstance.resourceId) && this.onUnpublishedSyncBlockDetected && (0, $dh538.fg)('platform_synced_block_dogfooding')) {
                // Remove from newly added set after checking to prevent duplicate flags
                this.newlyAddedSyncBlocks.delete(syncBlockInstance.resourceId);
                this.onUnpublishedSyncBlockDetected(resolvedSyncBlockInstance.resourceId);
            } else if (this.newlyAddedSyncBlocks.has(syncBlockInstance.resourceId)) // Remove from newly added set even if not unpublished (to clean up)
            this.newlyAddedSyncBlocks.delete(syncBlockInstance.resourceId);
            if (syncBlockInstance.error) {
                this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(syncBlockInstance.error.type, syncBlockInstance.resourceId));
                if (syncBlockInstance.error.type === (0, $awHlv.SyncBlockError).NotFound || syncBlockInstance.error.type === (0, $awHlv.SyncBlockError).Forbidden) hasExpectedError = true;
                else if (syncBlockInstance.error) hasUnexpectedError = true;
                return;
            } else if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.fireAnalyticsEvent?.((0, $cFpEg.fetchSuccessPayload)(syncBlockInstance.resourceId, syncBlockInstance.data?.blockInstanceId, syncBlockInstance.data?.product));
            this.fetchSyncBlockSourceInfo(resolvedSyncBlockInstance.resourceId);
        });
        if ((0, $dh538.fg)('platform_synced_block_dogfooding')) {
            if (hasUnexpectedError) this.fetchExperience?.failure({
                reason: 'Unexpected error during fetch'
            });
            else if (hasExpectedError) this.fetchExperience?.abort({
                reason: 'Expected error: NotFound or PermissionDenied'
            });
            else this.fetchExperience?.success();
        }
    }
    updateCacheWithSourceInfo(resourceId, sourceInfo) {
        const existingSyncBlock = this.getFromCache(resourceId);
        if (existingSyncBlock && existingSyncBlock.data) {
            existingSyncBlock.data.sourceURL = sourceInfo?.url;
            existingSyncBlock.data = {
                ...existingSyncBlock.data,
                sourceURL: sourceInfo?.url,
                sourceTitle: sourceInfo?.title,
                onSameDocument: sourceInfo?.onSameDocument,
                sourceSubType: sourceInfo?.subType
            };
            this.updateCache(existingSyncBlock);
        }
    }
    updateCache(syncBlock) {
        const { resourceId: resourceId } = syncBlock;
        if (resourceId) {
            this.syncBlockCache.set(resourceId, syncBlock);
            const callbacks = this.subscriptions.get(resourceId);
            if (callbacks) Object.values(callbacks).forEach((callback)=>{
                callback(syncBlock);
            });
        }
    }
    updateSourceTitleSubscriptions(resourceId, title) {
        const callbacks = this.titleSubscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(title);
        });
    }
    getFromCache(resourceId) {
        return this.syncBlockCache.get(resourceId);
    }
    deleteFromCache(resourceId) {
        this.syncBlockCache.delete(resourceId);
        this.providerFactories.delete(resourceId);
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        // Cancel any pending cache deletion for this resourceId.
        // This handles the case where a block is moved - the old component unmounts
        // (scheduling deletion) but the new component mounts and subscribes before
        // the deletion timeout fires.
        const pendingDeletion = this.pendingCacheDeletions.get(resourceId);
        if (pendingDeletion) {
            clearTimeout(pendingDeletion);
            this.pendingCacheDeletions.delete(resourceId);
        }
        // add to subscriptions map
        const resourceSubscriptions = this.subscriptions.get(resourceId) || {};
        const isNewResourceSubscription = Object.keys(resourceSubscriptions).length === 0;
        this.subscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        // New subscription means new reference synced block is added to the document
        this.isCacheDirty = true;
        // Notify listeners if this is a new resource subscription
        if (isNewResourceSubscription) this.notifySubscriptionChangeListeners();
        const syncBlockNode = (0, $gtauf.createSyncBlockNode)(localId, resourceId);
        // call the callback immediately if we have cached data
        // prefer cache from store manager first, should update data provider to use the same cache
        const cachedData = this.getFromCache(resourceId) || this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
        if (cachedData) callback(cachedData);
        else this.fetchSyncBlocksData([
            syncBlockNode
        ]).catch((error)=>{
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message, resourceId));
        });
        // Set up GraphQL subscription if real-time subscriptions are enabled
        if (this.useRealTimeSubscriptions) this.setupGraphQLSubscription(resourceId);
        return ()=>{
            const resourceSubscriptions = this.subscriptions.get(resourceId);
            if (resourceSubscriptions) {
                // Unsubscription means a reference synced block is removed from the document
                this.isCacheDirty = true;
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) {
                    this.subscriptions.delete(resourceId);
                    // Clean up GraphQL subscription when no more local subscribers
                    this.cleanupGraphQLSubscription(resourceId);
                    // Notify listeners that subscription was removed
                    this.notifySubscriptionChangeListeners();
                    // Delay cache deletion to handle block moves (unmount/remount).
                    // When a block is moved, the old component unmounts before the new one mounts.
                    // By delaying deletion, we give the new component time to subscribe and
                    // cancel this pending deletion, preserving the cached data.
                    // TODO: EDITOR-4152 - Rework this logic
                    const deletionTimeout = setTimeout(()=>{
                        // Only delete if still no subscribers (wasn't re-subscribed)
                        if (!this.subscriptions.has(resourceId)) this.deleteFromCache(resourceId);
                        this.pendingCacheDeletions.delete(resourceId);
                    }, 1000);
                    this.pendingCacheDeletions.set(resourceId, deletionTimeout);
                } else this.subscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    subscribeToSourceTitle(node, callback) {
        // check node is a sync block, as we only support sync block subscriptions
        if (node.type.name !== 'syncBlock') return ()=>{};
        const { resourceId: resourceId, localId: localId } = node.attrs;
        if (!localId || !resourceId) return ()=>{};
        const cachedData = this.getFromCache(resourceId);
        if (cachedData?.data?.sourceTitle) callback(cachedData.data.sourceTitle);
        // add to subscriptions map
        const resourceSubscriptions = this.titleSubscriptions.get(resourceId) || {};
        this.titleSubscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        return ()=>{
            const resourceSubscriptions = this.titleSubscriptions.get(resourceId);
            if (resourceSubscriptions) {
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) this.titleSubscriptions.delete(resourceId);
                else this.titleSubscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    subscribe(node, callback) {
        try {
            // check node is a sync block, as we only support sync block subscriptions
            if (node.type.name !== 'syncBlock') throw new Error('Only sync block node subscriptions are supported');
            const { resourceId: resourceId, localId: localId } = node.attrs;
            if (!localId || !resourceId) throw new Error('Missing local id or resource id');
            return this.subscribeToSyncBlock(resourceId, localId, callback);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
            return ()=>{};
        }
    }
    /**
   * Get the URL for a sync block.
   * @param resourceId - The resource ID of the sync block
   * @returns
   */ getSyncBlockURL(resourceId) {
        const syncBlock = this.getFromCache(resourceId);
        if (!syncBlock) return undefined;
        return syncBlock.data?.sourceURL;
    }
    getProviderFactory(resourceId) {
        if (!this.dataProvider) {
            const error = new Error('Data provider not set');
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
            return undefined;
        }
        const { parentDataProviders: parentDataProviders, providerCreator: providerCreator } = this.dataProvider.getSyncedBlockRendererProviderOptions();
        let providerFactory = this.providerFactories.get(resourceId);
        if (!providerFactory) {
            providerFactory = (0, $4FxUL.default).create({
                mentionProvider: parentDataProviders?.mentionProvider,
                profilecardProvider: parentDataProviders?.profilecardProvider,
                taskDecisionProvider: parentDataProviders?.taskDecisionProvider
            });
            this.providerFactories.set(resourceId, providerFactory);
        } else {
            if (parentDataProviders?.mentionProvider) providerFactory.setProvider('mentionProvider', parentDataProviders?.mentionProvider);
            if (parentDataProviders?.profilecardProvider) providerFactory.setProvider('profilecardProvider', parentDataProviders?.profilecardProvider);
            if (parentDataProviders?.taskDecisionProvider) providerFactory.setProvider('taskDecisionProvider', parentDataProviders?.taskDecisionProvider);
        }
        if (providerCreator) try {
            this.retrieveDynamicProviders(resourceId, providerFactory, providerCreator);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message, resourceId));
        }
        return providerFactory;
    }
    getSSRProviders(resourceId) {
        if (!(0, $dh538.fg)('platform_synced_block_dogfooding')) return null;
        if (!this.dataProvider) return null;
        const { providerCreator: providerCreator } = this.dataProvider.getSyncedBlockRendererProviderOptions();
        if (!providerCreator?.createSSRMediaProvider) return null;
        const parsedResourceId = (0, $47N43.parseResourceId)(resourceId);
        if (!parsedResourceId) return null;
        const { contentId: contentId, product: contentProduct } = parsedResourceId;
        try {
            const mediaProvider = providerCreator.createSSRMediaProvider({
                contentId: contentId,
                contentProduct: contentProduct
            });
            if (mediaProvider) return {
                media: mediaProvider
            };
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
        }
        return null;
    }
    retrieveDynamicProviders(resourceId, providerFactory, providerCreator) {
        if (!this.dataProvider) throw new Error('Data provider not set');
        const hasMediaProvider = providerFactory.hasProvider('mediaProvider');
        const hasEmojiProvider = providerFactory.hasProvider('emojiProvider');
        const hasCardProvider = providerFactory.hasProvider('cardProvider');
        if (hasMediaProvider && hasEmojiProvider && hasCardProvider) return;
        const syncBlock = this.getFromCache(resourceId);
        if (!syncBlock?.data) return;
        if (!syncBlock.data.sourceAri || !syncBlock.data.product) {
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)('Sync block source ari or product not found'));
            return;
        }
        const parentInfo = this.dataProvider.retrieveSyncBlockParentInfo(syncBlock.data?.sourceAri, syncBlock.data?.product);
        if (!parentInfo) throw new Error('Unable to retrive sync block parent info');
        const { contentId: contentId, contentProduct: contentProduct } = parentInfo;
        if (!hasMediaProvider) {
            if (providerCreator.createMediaProvider && contentId && contentProduct) {
                const mediaProvider = providerCreator.createMediaProvider({
                    contentProduct: contentProduct,
                    contentId: contentId
                });
                if (mediaProvider) providerFactory.setProvider('mediaProvider', mediaProvider);
            }
        }
        if (!hasEmojiProvider) {
            if (providerCreator.createEmojiProvider && contentId && contentProduct) {
                const emojiProvider = providerCreator.createEmojiProvider({
                    contentProduct: contentProduct,
                    contentId: contentId
                });
                if (emojiProvider) providerFactory.setProvider('emojiProvider', emojiProvider);
            }
        }
        if (!hasCardProvider) {
            if (providerCreator.createSmartLinkProvider) {
                const smartLinkProvider = providerCreator.createSmartLinkProvider();
                if (smartLinkProvider) providerFactory.setProvider('cardProvider', smartLinkProvider);
            }
        }
    }
    /**
   * Update reference synced blocks on the document with the BE
   *
   * @returns true if the reference synced blocks are updated successfully, false otherwise
   */ async flush() {
        if (!this.isCacheDirty) return true;
        let success = true;
        try {
            const blocks = [];
            // Collect all reference synced blocks on the current document
            Array.from(this.subscriptions.entries()).forEach(([resourceId, callbacks])=>{
                Object.keys(callbacks).forEach((localId)=>{
                    blocks.push({
                        resourceId: resourceId,
                        localId: localId
                    });
                });
            });
            if (!(0, $dh538.fg)('platform_synced_block_dogfooding')) // It's possible that the last reference block on the document was just deleted,
            // we still want to write to BE to update reference count
            {
                if (blocks.length === 0) {
                    this.isCacheDirty = false;
                    return true;
                }
            }
            if (!this.dataProvider) throw new Error('Data provider not set');
            // reset isCacheDirty early to prevent race condition
            // There is a race condition where if a user makes changes (create/delete) to a reference sync block
            // on a live page and the reference sync block is being saved while the user
            // is still making changes, the new changes might not be saved if they all happen
            // exactly at a time when the updateReferenceData is being executed asynchronously.
            this.isCacheDirty = false;
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.saveExperience?.start();
            const updateResult = await this.dataProvider.updateReferenceData(blocks);
            if (!updateResult.success) {
                success = false;
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.saveExperience?.failure({
                    reason: updateResult.error || 'Failed to update reference synced blocks on the document'
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.updateReferenceErrorPayload)(updateResult.error || 'Failed to update reference synced blocks on the document'));
            }
        } catch (error) {
            success = false;
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.saveExperience?.failure({
                reason: error.message
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.updateReferenceErrorPayload)(error.message));
        } finally{
            if (!success) // set isCacheDirty back to true for cases where it failed to update the reference synced blocks on the BE
            this.isCacheDirty = true;
            else if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.saveExperience?.success();
        }
        return success;
    }
    destroy() {
        // Clean up all GraphQL subscriptions first
        this.cleanupAllGraphQLSubscriptions();
        this.dataProvider = undefined;
        this.syncBlockCache.clear();
        this.subscriptions.clear();
        this.titleSubscriptions.clear();
        this.syncBlockFetchDataRequests.clear();
        this.syncBlockSourceInfoRequestsOld.clear();
        this.syncBlockSourceInfoRequests.clear();
        this.providerFactories.clear();
        this.isRefreshingSubscriptions = false;
        this.useRealTimeSubscriptions = false;
        this.subscriptionChangeListeners.clear();
        this.providerFactories.forEach((providerFactory)=>{
            providerFactory.destroy();
        });
        this.providerFactories.clear();
        this.saveExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fireAnalyticsEvent = undefined;
    }
    constructor(dataProvider){
        this.dataProvider = void 0;
        this.syncBlockCache = void 0;
        // Keeps track of addition and deletion of reference synced blocks on the document
        // This starts as true to always flush the cache when document is saved for the first time
        // to cater the case when a editor session is closed without document being updated right after reference block is deleted
        this.isCacheDirty = true;
        this.subscriptions = void 0;
        this.titleSubscriptions = void 0;
        this.providerFactories = void 0;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockFetchDataRequests = void 0;
        this.syncBlockSourceInfoRequestsOld = void 0;
        this.syncBlockSourceInfoRequests = void 0;
        this.isRefreshingSubscriptions = false;
        // Track pending cache deletions to handle block moves (unmount/remount)
        // When a block is moved, the old component unmounts before the new one mounts,
        // causing the cache to be deleted prematurely. We delay deletion to allow
        // the new component to subscribe and cancel the pending deletion.
        this.pendingCacheDeletions = void 0;
        // Track GraphQL subscriptions for real-time block updates
        this.graphqlSubscriptions = void 0;
        // Flag to indicate if real-time subscriptions are enabled
        this.useRealTimeSubscriptions = false;
        // Listeners for subscription changes (used by React components to know when to update)
        this.subscriptionChangeListeners = void 0;
        // Track newly added sync blocks (resourceIds that were just subscribed to without cached data)
        this.newlyAddedSyncBlocks = void 0;
        // Callback to notify when an unpublished sync block is detected
        this.onUnpublishedSyncBlockDetected = void 0;
        this.fetchExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        this.saveExperience = void 0;
        this.syncBlockCache = new Map();
        this.subscriptions = new Map();
        this.titleSubscriptions = new Map();
        this.dataProvider = dataProvider;
        this.syncBlockFetchDataRequests = new Map();
        this.syncBlockSourceInfoRequestsOld = new Map();
        this.syncBlockSourceInfoRequests = new Map();
        this.providerFactories = new Map();
        this.pendingCacheDeletions = new Map();
        this.graphqlSubscriptions = new Map();
        this.subscriptionChangeListeners = new Set();
        this.newlyAddedSyncBlocks = new Set();
    }
}
module.exports["ReferenceSyncBlockStoreManager"] = $bf9ff2ea047058dc$export$fb04276dca31302e;

});

parcelRegister("4wATI", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $awHlv = parcelRequire("awHlv");

const $165aef3c3dcb8be4$export$dcc459f28c1cd2fd = (oldResult, newResult)=>{
    // if the old result has no data, we simply return the new result
    if (!oldResult.data) return newResult;
    else if (!newResult.data) {
        // return the old result if there was an error, e.g. network error, but not if not found or forbidden
        if (newResult.error?.type === (0, $awHlv.SyncBlockError).NotFound || newResult.error?.type === (0, $awHlv.SyncBlockError).Forbidden) return newResult;
        else return oldResult;
    }
    // otherwise, we merge the two results, preserving the sourceURL and sourceTitle from the old result if it exists
    return {
        ...newResult,
        data: {
            ...newResult.data,
            sourceURL: newResult.data?.sourceURL || oldResult.data?.sourceURL || undefined,
            sourceTitle: newResult.data?.sourceTitle || oldResult.data?.sourceTitle || undefined,
            ...(0, $dh538.fg)('platform_synced_block_dogfooding') && {
                sourceSubType: newResult.data?.sourceSubType || oldResult.data?.sourceSubType || undefined,
                onSameDocument: newResult.data?.onSameDocument || oldResult.data?.onSameDocument || undefined
            }
        }
    };
};
module.exports["resolveSyncBlockInstance"] = $165aef3c3dcb8be4$export$dcc459f28c1cd2fd;

});

parcelRegister("dBGrG", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $QkKjT = parcelRequire("QkKjT");


var $gtauf = parcelRequire("gtauf");

class $297b92badcfd6d6a$export$9c6faa8962092f36 {
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.createExperience = (0, $QkKjT.getCreateSourceExperience)(fireAnalyticsEvent);
        this.saveExperience = (0, $QkKjT.getSaveSourceExperience)(fireAnalyticsEvent);
        this.deleteExperience = (0, $QkKjT.getDeleteSourceExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $QkKjT.getFetchSourceInfoExperience)(fireAnalyticsEvent);
    }
    isSourceBlock(node) {
        return node.type.name === 'bodiedSyncBlock';
    }
    /**
   * Add/update a sync block node to/from the local cache
   * @param syncBlockNode - The sync block node to update
   */ updateSyncBlockData(syncBlockNode) {
        try {
            if (!this.isSourceBlock(syncBlockNode)) throw new Error('Invalid sync block node type provided for updateSyncBlockData');
            const { localId: localId, resourceId: resourceId } = syncBlockNode.attrs;
            if (!localId || !resourceId) throw new Error('Local ID or resource ID is not set');
            const syncBlockData = (0, $gtauf.convertSyncBlockPMNodeToSyncBlockData)(syncBlockNode);
            this.syncBlockCache.set(resourceId, {
                ...syncBlockData,
                isDirty: true
            });
            return true;
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.updateCacheErrorPayload)(error.message));
            return false;
        }
    }
    /**
   * Save content of bodiedSyncBlock nodes in local cache to backend
   *
   * @returns true if saving all nodes successfully, false if fail to save some/all nodes
   */ async flush() {
        try {
            const bodiedSyncBlockNodes = [];
            const bodiedSyncBlockData = [];
            Array.from(this.syncBlockCache.values()).forEach((syncBlockData)=>{
                // Don't flush nodes that are waiting to be deleted to avoid nodes being re-created
                // Don't flush nodes that haven't been updated since we last flushed
                if (!syncBlockData.pendingDeletion && syncBlockData.isDirty) {
                    bodiedSyncBlockNodes.push({
                        type: 'bodiedSyncBlock',
                        attrs: {
                            localId: syncBlockData.blockInstanceId,
                            resourceId: syncBlockData.resourceId
                        }
                    });
                    bodiedSyncBlockData.push(syncBlockData);
                    // reset isDirty early to prevent race condition
                    // There is a race condition where if a user makes changes to a source sync block
                    // on a live page and the source sync block is being saved while the user
                    // is still making changes, the new changes might not be saved if they all happen
                    // exactly at a time when the writeNodesData is being executed asynchronously.
                    syncBlockData.isDirty = false;
                }
            });
            if (bodiedSyncBlockNodes.length === 0) return Promise.resolve(true);
            if (!this.dataProvider) throw new Error('Data provider not set');
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.saveExperience?.start({});
            const writeResults = await this.dataProvider.writeNodesData(bodiedSyncBlockNodes, bodiedSyncBlockData);
            writeResults.forEach((result)=>{
                // set isDirty to true for cases where it failed to save the sync block to the BE
                if (result.resourceId && result.error && result.error !== (0, $awHlv.SyncBlockError).NotFound) {
                    const cachedData = this.syncBlockCache.get(result.resourceId);
                    if (cachedData) cachedData.isDirty = true;
                }
            });
            if (writeResults.every((result)=>result.resourceId && !result.error)) {
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) {
                    this.saveExperience?.success();
                    writeResults.forEach((result)=>{
                        if (result.resourceId && !result.error) this.fireAnalyticsEvent?.((0, $cFpEg.updateSuccessPayload)(result.resourceId, false));
                    });
                }
                return true;
            } else {
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.saveExperience?.failure();
                writeResults.filter((result)=>!result.resourceId || result.error).forEach((result)=>{
                    this.fireAnalyticsEvent?.((0, $cFpEg.updateErrorPayload)(result.error || 'Failed to write data', result.resourceId));
                });
                return false;
            }
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.updateErrorPayload)(error.message));
            return false;
        }
    }
    registerPendingCreation(resourceId) {
        this.pendingResourceId = resourceId;
    }
    /**
   * Register callback function (which inserts node, handles focus etc) to be used later when creation to backend succeed
   */ registerCreationCallback(callback) {
        this.creationCallback = callback;
    }
    /**
   *  Fires callback to insert node (if creation is successful) and clears pending creation data
   * @param success
   */ commitPendingCreation(success) {
        if (success && this.creationCallback) {
            this.creationCallback();
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.fireAnalyticsEvent?.((0, $cFpEg.createSuccessPayload)(this.pendingResourceId || ''));
        } else if (success && !this.creationCallback && (0, $dh538.fg)('platform_synced_block_dogfooding')) this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)('creation callback missing', this.pendingResourceId));
        this.pendingResourceId = undefined;
        this.creationCallback = undefined;
    }
    /**
   *
   * @returns true if waiting for the result of saving new bodiedSyncBlock to backend
   */ hasPendingCreation() {
        return !!this.pendingResourceId;
    }
    registerConfirmationCallback(callback) {
        this.confirmationCallback = callback;
        return ()=>{
            this.confirmationCallback = undefined;
        };
    }
    requireConfirmationBeforeDelete() {
        return !!this.confirmationCallback;
    }
    /**
   * @returns attributes for a new bodiedSyncBlock node
   */ generateBodiedSyncBlockAttrs() {
        if (!this.dataProvider) throw new Error('Data provider not set or source id not set');
        const { resourceId: resourceId, localId: localId } = this.dataProvider.generateResourceId();
        return {
            resourceId: resourceId,
            localId: localId
        };
    }
    /**
   * Create a bodiedSyncBlock node with empty content to backend
   * @param attrs attributes Ids of the node
   */ createBodiedSyncBlockNode(attrs, nodeData) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const { resourceId: resourceId, localId: blockInstanceId } = attrs;
            this.createExperience?.start({});
            this.dataProvider.createNodeData({
                content: [],
                blockInstanceId: blockInstanceId,
                resourceId: resourceId
            }).then((result)=>{
                const resourceId = result.resourceId;
                if (resourceId) {
                    this.commitPendingCreation(true);
                    if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.createExperience?.success();
                    // Update the sync block data with the node data if it is provided
                    // to avoid any race conditions where the data could be missed during a render operation
                    if (nodeData) this.updateSyncBlockData(nodeData);
                } else {
                    this.commitPendingCreation(false);
                    if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.createExperience?.failure({
                        reason: result.error || 'Failed to create bodied sync block'
                    });
                    this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(result.error || 'Failed to create bodied sync block', resourceId));
                }
            }).catch((error)=>{
                this.commitPendingCreation(false);
                (0, $hWRJP.logException)(error, {
                    location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
                });
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.createExperience?.failure({
                    reason: error.message
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(error.message, resourceId));
            });
            this.registerPendingCreation(resourceId);
        } catch (error) {
            if (this.hasPendingCreation()) this.commitPendingCreation(false);
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(error.message));
        }
    }
    async delete(syncBlockIds, onDelete, onDeleteCompleted, reason) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, true);
            });
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.deleteExperience?.start({});
            const results = await this.dataProvider.deleteNodesData(syncBlockIds.map((attrs)=>attrs.resourceId), reason);
            let callback;
            const isDeleteSuccessful = results.every((result)=>result.success);
            onDeleteCompleted(isDeleteSuccessful);
            if (isDeleteSuccessful) {
                onDelete();
                callback = (Ids)=>this.syncBlockCache.delete(Ids.resourceId);
                this.clearPendingDeletion();
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) {
                    this.deleteExperience?.success();
                    results.forEach((result)=>{
                        this.fireAnalyticsEvent?.((0, $cFpEg.deleteSuccessPayload)(result.resourceId));
                    });
                }
            } else {
                callback = (Ids)=>{
                    this.setPendingDeletion(Ids, false);
                };
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) {
                    this.deleteExperience?.failure();
                    results.forEach((result)=>{
                        if (result.success) this.fireAnalyticsEvent?.((0, $cFpEg.deleteSuccessPayload)(result.resourceId));
                        else this.fireAnalyticsEvent?.((0, $cFpEg.deleteErrorPayload)(result.error || 'Failed to delete synced block', result.resourceId));
                    });
                } else results.filter((result)=>result.resourceId === undefined).forEach((result)=>{
                    this.fireAnalyticsEvent?.((0, $cFpEg.deleteErrorPayload)(result.error || 'Failed to delete synced block'));
                });
            }
            syncBlockIds.forEach(callback);
            return isDeleteSuccessful;
        } catch (error) {
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, false);
                this.fireAnalyticsEvent?.((0, $cFpEg.deleteErrorPayload)(error.message, Ids.resourceId));
            });
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            onDeleteCompleted(false);
            return false;
        }
    }
    isRetryingDeletion() {
        return !!this.deletionRetryInfo;
    }
    async retryDeletion() {
        if (!this.deletionRetryInfo) return Promise.resolve();
        const { syncBlockIds: syncBlockIds, onDelete: onDelete, onDeleteCompleted: onDeleteCompleted, deletionReason: deletionReason } = this.deletionRetryInfo;
        if (this.confirmationCallback) await this.delete(syncBlockIds, onDelete, onDeleteCompleted, deletionReason);
    }
    clearPendingDeletion() {
        this.deletionRetryInfo?.destroyCallback();
        this.deletionRetryInfo = undefined;
    }
    /**
   *
   * @param syncBlockIds - The sync block ids to delete
   * @param onDelete - The callback to delete sync block node from document
   * @param onDeleteCompleted - The callback for after the deletion is saved to BE (whether successful or not)
   * @param destroyCallback - The callback to clear any reference stored for deletion (regardless if deletion is completed or abort)
   */ async deleteSyncBlocksWithConfirmation(syncBlockIds, deletionReason, onDelete, onDeleteCompleted, destroyCallback) {
        if (this.confirmationCallback) {
            const confirmed = await this.confirmationCallback(syncBlockIds, deletionReason);
            if (confirmed) {
                const isDeleteSuccessful = await this.delete(syncBlockIds, onDelete, onDeleteCompleted, deletionReason);
                if (!isDeleteSuccessful) // If deletion failed, save deletion info for potential retry
                this.deletionRetryInfo = {
                    syncBlockIds: syncBlockIds,
                    onDelete: onDelete,
                    onDeleteCompleted: onDeleteCompleted,
                    destroyCallback: destroyCallback,
                    deletionReason: deletionReason
                };
                else destroyCallback();
            } else destroyCallback();
        }
    }
    getSyncBlockSourceInfo(localId) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.fetchSourceInfoExperience?.start();
            return this.dataProvider.fetchSyncBlockSourceInfo(localId, undefined, undefined, this.fireAnalyticsEvent).then((sourceInfo)=>{
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) {
                    if (!sourceInfo) this.fetchSourceInfoExperience?.failure({
                        reason: 'No source info returned'
                    });
                    else this.fetchSourceInfoExperience?.success();
                }
                return sourceInfo;
            });
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchReferences(resourceId) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            return this.dataProvider.fetchReferences(resourceId, true);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchReferencesErrorPayload)(error.message));
            return Promise.resolve({
                error: (0, $awHlv.SyncBlockError).Errored
            });
        }
    }
    destroy() {
        this.syncBlockCache.clear();
        this.confirmationCallback = undefined;
        this.pendingResourceId = undefined;
        this.creationCallback = undefined;
        this.dataProvider = undefined;
        this.saveExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.createExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.deleteExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.clearPendingDeletion();
    }
    constructor(dataProvider){
        this.dataProvider = void 0;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockCache = void 0;
        this.confirmationCallback = void 0;
        this.deletionRetryInfo = void 0;
        this.pendingResourceId = void 0;
        this.creationCallback = void 0;
        this.createExperience = void 0;
        this.saveExperience = void 0;
        this.deleteExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        this.setPendingDeletion = (Ids, value)=>{
            const syncBlock = this.syncBlockCache.get(Ids.resourceId);
            if (syncBlock) syncBlock.pendingDeletion = value;
        };
        this.dataProvider = dataProvider;
        this.syncBlockCache = new Map();
    }
}
module.exports["SourceSyncBlockStoreManager"] = $297b92badcfd6d6a$export$9c6faa8962092f36;

});

parcelRegister("a7tZV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $gtauf = parcelRequire("gtauf");

const $fb1e42d9cacf5d6e$export$2b02427d5640395b = (manager, resourceId, localId, fireAnalyticsEvent)=>{
    // Initialize both states from a single cache lookup to avoid race conditions.
    // When a block is moved/remounted, the old component's cleanup may clear the cache
    // before or after the new component mounts. By doing a single lookup, we ensure
    // consistency between syncBlockInstance and isLoading initial values.
    const [{ syncBlockInstance: syncBlockInstance, isLoading: isLoading }, setFetchState] = (0, $42omo.useState)(()=>{
        if (resourceId) {
            const initialData = manager?.referenceManager?.getInitialSyncBlockData(resourceId);
            return {
                syncBlockInstance: initialData ?? null,
                isLoading: initialData === undefined
            };
        }
        return {
            syncBlockInstance: null,
            isLoading: true
        };
    });
    const reloadData = (0, $42omo.useCallback)(async ()=>{
        if (isLoading) return;
        try {
            const syncBlockNode = resourceId && localId ? (0, $gtauf.createSyncBlockNode)(localId, resourceId) : null;
            if (!syncBlockNode) throw new Error('Failed to create sync block node from resourceid and localid');
            setFetchState((prev)=>({
                    ...prev,
                    isLoading: true
                }));
            // Fetch sync block data, the `subscribeToSyncBlock` will update the state once data is fetched
            await manager.referenceManager.fetchSyncBlocksData([
                syncBlockNode
            ]);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/useFetchSyncBlockData'
            });
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) manager?.referenceManager?.fetchExperience?.failure({
                reason: error.message
            });
            else fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
            // Set error state if fetching fails
            setFetchState({
                syncBlockInstance: {
                    resourceId: resourceId || '',
                    error: {
                        type: (0, $awHlv.SyncBlockError).Errored
                    }
                },
                isLoading: false
            });
            return;
        }
        setFetchState((prev)=>({
                ...prev,
                isLoading: false
            }));
    }, [
        isLoading,
        localId,
        manager.referenceManager,
        resourceId,
        fireAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = manager.referenceManager.subscribeToSyncBlock(resourceId || '', localId || '', (data)=>{
            setFetchState({
                syncBlockInstance: data,
                isLoading: false
            });
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        localId,
        manager.referenceManager,
        resourceId
    ]);
    const ssrProviders = (0, $42omo.useMemo)(()=>{
        return resourceId ? manager.referenceManager.getSSRProviders(resourceId) : null;
    }, [
        resourceId,
        manager.referenceManager
    ]);
    return {
        isLoading: isLoading,
        ssrProviders: ssrProviders,
        providerFactory: manager.referenceManager.getProviderFactory(resourceId || ''),
        reloadData: reloadData,
        syncBlockInstance: syncBlockInstance
    };
};
module.exports["useFetchSyncBlockData"] = $fb1e42d9cacf5d6e$export$2b02427d5640395b;

});


//# sourceMappingURL=CommentsPanelFilterMenu.bc03cad2.js.map
